import { configureStore } from '@reduxjs/toolkit';
import authReducer from '../reducers/AuthReducer';
import SelectCenterReducer from '../reducers/SelectCenterReducer';
import { apiSlice } from '../api/apiSlice';

/**
 *
 * @name store
 * @description The redux store
 * @version 1.0.0
 *
 */
export const store = configureStore({
	reducer: {
		auth: authReducer,
		selectedCenter: SelectCenterReducer,
		[apiSlice.reducerPath]: apiSlice.reducer,
	},

	middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(apiSlice.middleware),
});

// Types for typed hooks
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
